<template>
  <div class="invitacion-container">
    <!-- Ramitas decorativas -->
    <img
      ref="ramaIzquierda"
      class="ramita izquierda"
      src="@/assets/ramita.avif"
      alt="Decoración izquierda"
    />
    <img
      ref="ramaDerecha"
      class="ramita derecha"
      src="@/assets/ramita.avif"
      alt="Decoración derecha"
    />

    <div class="invitacion-card">
      <img 
        ref="sello"
        src="@/assets/1.png" 
        alt="Sello decorativo" 
        class="sello-decorativo" 
      />

      <div class="seccion-idiomas" ref="idiomaSeccion">
        <div class="opciones-idioma">
          <button @click="seleccionar('es')" class="btn-idioma">
            <span>Ingresar</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import gsap from 'gsap'

export default {
  name: 'InvitacionIdioma',
  emits: ['idioma-seleccionado'],
  setup(_, { emit }) {
    const ramaIzquierda = ref(null)
    const ramaDerecha = ref(null)
    const sello = ref(null)
    const idiomaSeccion = ref(null)

    const seleccionar = idioma => {
      emit('idioma-seleccionado', idioma)
    }

    onMounted(() => {
      // Animación de las ramas (lados)
      gsap.from([ramaIzquierda.value, ramaDerecha.value], {
        opacity: 0,
        scale: 0.8,
        duration: 1.2,
        ease: 'power2.out'
      })

      // Animación del Sello y el Botón (aparecen rápido)
      const tl = gsap.timeline();
      
      tl.from(sello.value, {
        opacity: 0,
        y: 20,
        duration: 0.8,
        ease: 'power3.out'
      })
      .from(idiomaSeccion.value, {
        opacity: 0,
        y: 10,
        duration: 0.6,
        ease: 'power2.out'
      }, "-=0.4"); // Inicia un poco antes de que termine el sello
    })

    return {
      seleccionar,
      ramaIzquierda,
      ramaDerecha,
      sello,
      idiomaSeccion,
    }
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&family=Montserrat:wght@300;400;500&family=Dancing+Script:wght@700&display=swap');

.invitacion-container {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center; 
  align-items: center;      /* Centrado vertical */
  min-height: 100vh;
  background-color: #fff;
  overflow: hidden;
}

.ramita {
  position: absolute;
  top: 50%;
  width: 0px !important;             /* Ajustado para que se vea */
  transform: translateY(-50%);
  z-index: 0;
  pointer-events: none;
  opacity: 0.6;
}
.ramita.izquierda { left: -20px; }
.ramita.derecha { right: -20px; transform: translateY(-50%) scaleX(-1); }

.invitacion-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  text-align: center;
  width: 100%;
  max-width: 520px; 
  z-index: 1;
}

.sello-decorativo {
  width: 300px !important;
  height: auto;
  margin-bottom: 30px;
  opacity: 0.9;
}

.seccion-idiomas { 
  width: 100%;
}

.opciones-idioma {
  display: flex;
  justify-content: center;
}

.btn-idioma {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 40px;
  font-size: 1.1rem;
  font-family: 'Montserrat', sans-serif;
  background: #fff;
  border: 1px solid #e8c4c4;
  border-radius: 12px;
  color: #ae9980;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  text-transform: uppercase;
  letter-spacing: 2px;
}

.btn-idioma:hover {
  background: #fdf8f8;
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  border-color: #ae9980;
}

@media (max-width: 480px) {
  .invitacion-card { max-width: 90vw; }
  .sello-decorativo { width: 80%; }
  .ramita { width: 100px; }
}
</style>